function phoneClear(phone: string | null | undefined): string {
  return (phone || '')
    .replaceAll(' ', '')
    .replaceAll('+', '')
    .replaceAll('(', '')
    .replaceAll(')', '')
    .replaceAll('-', '');
}

export default phoneClear;
